import React from 'react'

import { wrapCurrencyFactory } from './currency'

export type IProps = {
  currencyCode: string
  price: number
}

const CurrencyPrice = (props: IProps & any) => {
  const { currencyCode, price, ...rest } = props
  const wrapCurrency = wrapCurrencyFactory(currencyCode)

  return (
    <span
      {...rest}
      dangerouslySetInnerHTML={{ __html: wrapCurrency(price) }}
    ></span>
  )
}

export default CurrencyPrice
